import {
    ERROR_RESPONSE,RESET_RESPONSE_POLICY
  } from "./types"

  const initialState = {
    message:"",
  };
  
  const errorReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case ERROR_RESPONSE:
        return { ...state, message: payload.errorMessage };
        case RESET_RESPONSE_POLICY:
        return { ...initialState,};
      default:
        return state;
    }
  };
  
  export default errorReducer;
  